export class PriceRangeModel {
  volMin: number;
  volMax: number;
  price: number;

  constructor(volMin?: number, volMax?: number, price?: number) {
    this.volMin = volMin;
    this.volMax = volMax;
    this.price = price;
  }
}
